import React, { useState, useEffect, useRef } from 'react';
import './order-list.css';
import { BreadCrumb } from 'primereact/breadcrumb';
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Form from 'react-bootstrap/Form';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Dialog } from 'primereact/dialog';
import moment from 'jalali-moment';
import { Toast } from 'primereact/toast';
import Loader from '../loader/loader'
import { GetAllOrders, customerFactor, getOrderInfo, payment, GetfactorPdf, getOpenOrders } from '../../utils/api';
import { Dropdown } from 'primereact/dropdown';
import Box from '../../assets/icons/ticket/box.svg';
import Printer from '../../assets/icons/printer.svg';
import AddTicket from '../tickets/addTicket';


//icon
import Factor from '../../assets/icons/order/factor.svg';
import Calendar from '../../assets/icons/order/calendar.svg';
import Clipboard from '../../assets/icons/order/clipboard.svg';
import Shop from '../../assets/icons/order/shop.svg';
import Cards from '../../assets/icons/order/cards.svg';
import TextBox from '../../assets/icons/order/textBox.svg';
import Map from '../../assets/icons/order/map.svg';
import City from '../../assets/icons/order/city.svg';
import Payment from '../../assets/icons/order/payment.svg';
import Time from '../../assets/icons/order/time.svg';
import Phone from '../../assets/icons/order/phone.svg';
import User from '../../assets/icons/order/user.svg';
import Arrow from '../../assets/icons/arrow-down.svg';
import { use } from 'react';
import UploadIcon from '../../assets/icons/ticket/upload.svg';

function Orders() {
    const toast = useRef(null);
    const [shouldOpenCalendar, setShouldOpenCalendar] = useState(false)
    const datePickerRef = useRef(null);
    const datePickerRef1 = useRef(null);
    const mobileDatePickerRef1 = useRef(null);
    const mobileDatePickerRef = useRef(null);
    const [validated, setValidated] = useState(false)

    const [visibleTicketDialog, setVisibleTicketDialog] = useState(false)
    const [visiblePaymentDialog, setVisiblePaymentDialog] = useState(false)
    const [visibleDetailDialog, setVisibleDetailDialog] = useState(false); // Dialog visibility state
    const [fromDate, setFromDate] = useState(null);
    // const [toDate, setToDate] = useState(null);
    const [status, setStatus] = useState('');
    const [factorNumber, setFactorNumber] = useState('');
    const [orderID, setOrderID] = useState('');
    const [totalAmount, setTotalAmount] = useState('');
    const [searchLoader, setSearchLoader] = useState(false);
    const [customerData, setCustomerData] = useState();
    const [dataOrders, setDataOrders] = useState('');
    const [factorListMap, setFactorListMap] = useState([]);
    const [loading, setLoading] = useState(false);
    const [productName, setProductName] = useState('');
    const [BranchName, setBranchName] = useState('');
    const [toDate, setToDate] = useState(null);
    const items = [{ label: 'سفارشات من' }];
    const [loader, setLoader] = useState(false);
    const [file, setFile] = useState(null);
    const [factorId, setFactorId] = useState('');

    //payment
    const [paymentData, setPaymentDate] = useState(null);
    const [paymentAmount, setPaymentAmount] = useState('');
    const [paymentAccount, setPaymentAccount] = useState('');
    const [trackingNumber, setTrackingNumber] = useState('');
    const [description, setDescription] = useState('');


    const handleAmountChange = (input) => {
        const rawValue = input.replace(/,/g, ''); // Remove existing commas
        if (/^\d*$/.test(rawValue)) { // Ensure the value is numeric
            setPaymentAmount(rawValue);
        }
    };
    const formatAmount = (value) => {
        if (!value) return '';
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas as thousand separators
    };

    const home = { label: 'باشگاه مشتریان', url: '/' };
    const [date, setDates] = useState([
        new DateObject().setMonth(new Date().getMonth() - 5),
        new DateObject(),
    ])

    // isSettingTo uses only when the 'to date' datepicker opens to detect user's setting the 'to date' and prevent setting the 'from date' again.
    const [isSettingTo, setIsSettingTo] = useState(false);
    const [isSettingfrom, setIsSettingfrom] = useState(false);

    const onDateRangeChanged = (location, e) => {
        if (isSettingfrom) {
            handleFocus1()
            mobileHandleFocus1()
            closefromCalendar()
            mobileClosefromCalendar()
        } else if (!isSettingfrom && !isSettingTo) {
            handleFocus()
            mobileHandleFocus()
            closeToCalendar()
            mobileCloseToCalendar()
        }
        if (isSettingTo) {
            if (e[0].format().toString() == date[0].format().toString()) {
                setDates(e);
            } else {
                setDates((old) => {
                    old[1] = e[0];
                    return old;
                });
                setIsSettingTo(false);
            }


        }
        else {
            setDates(e);
        }
    };
    const onCalenderOpened = (e) => {

        if (e === 'to') {
            setIsSettingTo(true);
            setIsSettingfrom(false)
        }
        if (e === 'from') {
            setIsSettingfrom(true)
            setIsSettingTo(false);

        }

    };

    const formatDateObject = (dateObject) => {
        if (!dateObject) return "";
        const startDate = dateObject.split(' ~ ')[0];
        return startDate;
    };
    const formatDateObjectTo = (dateObject) => {
        if (!dateObject) return "";
        const endDate = dateObject.split(' ~ ')[1];
        return endDate;
    };
    const handleFocus = () => {
        if (datePickerRef.current) {
            datePickerRef.current.openCalendar();
        }
    };
    const closefromCalendar = () => {
        if (datePickerRef.current) {
            datePickerRef.current.closeCalendar();
        }
    };
    const closeToCalendar = () => {
        if (datePickerRef1.current) {
            datePickerRef1.current.closeCalendar();
        }
    };
    const mobileClosefromCalendar = () => {
        if (mobileDatePickerRef.current) {
            mobileDatePickerRef.current.closeCalendar();
        }
    };
    const mobileCloseToCalendar = () => {
        if (mobileDatePickerRef1.current) {
            mobileDatePickerRef1.current.closeCalendar();
        }
    };
    const handleFocus1 = () => {
        if (datePickerRef1.current) {
            datePickerRef1.current.openCalendar();
        }
    };
    const mobileHandleFocus = () => {
        if (mobileDatePickerRef.current) {
            mobileDatePickerRef.current.openCalendar();
        }
    };
    const mobileHandleFocus1 = () => {
        if (mobileDatePickerRef1.current) {
            mobileDatePickerRef1.current.openCalendar();
        }
    };
    // When the date range changes, update fromDate and toDate
    useEffect(() => {
        if (date && date.length === 2) {

            setFromDate(date[0]);
            setToDate(date[1]);
        }
    }, [date]);



    const showSuccess = (success) => {
        toast.current.show({ severity: 'success', detail: success.text, life: 3000 });
    }
    const showError = (error) => {
        toast.current.show({ severity: 'error', detail: error.text, life: 3000 });
    }
    const ordersData = async (pay) => {
        try {
            setSearchLoader(true)
            let res = await getOpenOrders(pay);
            if (res.status === 200) {
                getOrderData(res.data);
                setSearchLoader(false)
            }
        } catch (error) {
            setSearchLoader(true)
            // Handle the error appropriately, e.g., show an error message to the user, log it, etc.
        } finally {
        }
    };

    const getOrderData = async (res) => {
        setDataOrders(res);
        let amount = 0;

        for (const order of res) {
            await getCustomerFactor(JSON.parse(window.localStorage.getItem('userInfo')).si, order.Si); // منتظر می‌مونه تا درخواست تکمیل بشه
        }

        setTotalAmount(amount);
    };
    useEffect(() => {
        let customerDatares = window.localStorage.getItem('userInfo');
        setCustomerData(JSON.parse(customerDatares));
        let toDateNew = moment.now();
        let fd = new Date();
        fd.setMonth(fd.getMonth() - 6);
        let fromDateNew = fd;
        setToDate(toDateNew);
        setFromDate(fromDateNew);

        let pay = {

            userId: JSON.parse(customerDatares).si,

        };
        console.log('......')
        ordersData(pay);
    }, []);

    useEffect(() => {
    }, [fromDate, toDate])




    const convertDateToPersian = (date) => {
        if (!date) return '-';
        return moment(date).locale("fa").format("YYYY/MM/DD");
    };
    const getCustomerFactor = async (customerId, orderId) => {
        let pay = { userId: customerId, orderId: orderId };
        let factorData = await customerFactor(pay); // API call

        let newProducts = factorData.data

        setOrderID(orderId);
        setFactorListMap((prevList) => [...prevList, ...newProducts]);
    };



    useEffect(() => {
    }, [factorListMap])


    const searchOrder = async () => {
        let payload = {

            userId: JSON.parse(localStorage.getItem('userInfo')).si,

        };
        ordersData(payload);
    };



    function convertPersianDigitsToEnglish(text) {
        // Define a mapping of Persian digits to English digits
        const persianToEnglishDigits = {
            '۰': '0',
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9'
        };

        // Use a regular expression to find Persian digits and replace them
        return text.replace(/[۰-۹]/g, function (match) {
            return persianToEnglishDigits[match];
        });
    }


    const statusOption = [
        { name: 'در دست بررسی', code: 'A' },
        { name: 'ابطال شده', code: 'B' },
        { name: 'ثبت شده', code: 'C' },
        { name: 'درحال تولید', code: 'D' },
    ];
    const handleDialogClose = () => {
        setVisibleDetailDialog(false);

    };

    const handleTicketDialogClose = () => {
        setVisibleTicketDialog(false);

    };
    const [filePreview, setFilePreview] = useState(null);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);

        if (selectedFile && selectedFile.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFilePreview(reader.result); // base64 image preview
            };
            reader.readAsDataURL(selectedFile);
        } else {
            setFilePreview(null);
        }
    };

    const handleFileClick = () => {
        document.getElementById('file-upload').click();
    };
    const [orderDetails, setOrderDetails] = useState(null)
    const openOrderDetail = async (id) => {
        try {
            let pay = {
                userId: JSON.parse(localStorage.getItem('userInfo')).si,
                orderId: id
            }
            let res = await getOrderInfo(pay)
            if (res.status == 200) {
                setOrderDetails(res.data)
                setVisibleDetailDialog(true)
            }
        } catch (error) {

        }
    }
    const [orderNum, setOrderNum] = useState('')
    const openTicketDialog = (id) => {
        setOrderNum(id)
        setVisibleTicketDialog(true)
    }
    function convertToPersianNumbers(input) {
        if (input) {

            const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
            return input.replace(/\d/g, (digit) => persianDigits[digit]);
        }
    }

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onloadend = () => {
                const base64String = reader.result;
                const extension = file.name.split('.').pop().toLowerCase();

                resolve({
                    base64: base64String,
                    extension: extension,
                });
            };

            reader.onerror = (error) => {
                reject(error);
            };

            reader.readAsDataURL(file);
        });
    };

    const uploadForm = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === true) {
            event.stopPropagation();
            try {
                if (!paymentData || paymentData == '') {
                    showError('لطفا تاریخ پرداخت را وارد کنید.')
                    return
                }
                let base64 = "";
                let extension = "";
                if (file) {
                    const result = await convertFileToBase64(file);
                    base64 = result.base64;
                    extension = result.extension;
                } else {
                    showError('لطفا فیش پرداختی را اپلود کنید.')
                    return
                }
                setLoader(true);

                let pay = {
                    userId: (JSON.parse(window.localStorage.getItem('userInfo')).si).toString(),
                    date: paymentData,
                    orderId: factorId.toString(),
                    cash: paymentAmount,
                    peygiri: trackingNumber,
                    hesab: paymentAccount,
                    sharh: description,
                    type: extension,  // پسوند فایل
                    image: base64
                }
                let response = await payment(pay);

                if (response.data.res === 'OK') {

                    setLoader(false)
                    showSuccess(response.data.restp);

                } else if (response.data.res === 'NotOk') {
                    setLoader(false);

                    let error = {
                        title: 'اخطار',
                        text: response.data.restp,
                    };
                    showError(error);
                }
            } catch (error) {
                setLoader(false);
                console.log(error);
                showError('خطا در برقراری ارتباط...');
            }
        }

        setValidated(true);
    }

    const getPdf = async (id) => {
        try {
            let payload = {
                userId: (JSON.parse(window.localStorage.getItem('userInfo')).si).toString(),
                factorId: id
            };

            let res = await GetfactorPdf(payload);

            // باز کردن عکس در تب جدید
            window.open(res.data, '_blank');



        } catch (error) {
            console.error('Error while generating image', error);
        }
    };

    const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]
    return (
        <div>
            <Toast ref={toast} />
            <div className='contain'>
                <div className='order-body'>



                    {(!!dataOrders && dataOrders.length > 0) && dataOrders.map((order) =>
                        <div className='ticket-box mt-2 ' key={order.Si}>
                            <div className='row gy-4'>
                                <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                    <img src={Factor} alt="" />
                                    <h6 className='m-0 f-14 '>شماره سفارش: {convertToPersianNumbers((order.Si).toString())}</h6>
                                </div>
                                <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                    <img src={Calendar} alt="" />
                                    <h6 className='m-0 f-14 '>تاریخ ثبت سفارش: {convertToPersianNumbers(order.DateSabt)}</h6>
                                </div>
                                <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                    <img src={Calendar} alt="" />
                                    <h6 className='m-0 f-14 '> تاریخ تحویل: {convertToPersianNumbers(order.DateTahvil)}</h6>
                                </div>

                                <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                    <img src={Cards} alt="" />
                                    <h6 className='m-0 f-14 number-font'>مبلغ: {parseInt((order.Payment).toString()).toLocaleString()} ریال</h6>
                                </div>
                                <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                    <img src={Clipboard} alt="" />
                                    <h6 className='m-0 f-14 d-flex align-items-center gap-1' >وضعیت: <h6 className='m-0 f-14 font-semibold' style={{
                                        color: order.Sit === 'A' ? 'blue' :
                                            order.Sit === 'B' ? 'red' :
                                                order.Sit === 'C' ? 'green' : 
                                                order.Sit === 'E' ? '#ff7800' : 
                                                  order.Sit === 'F' ? '#00c7e3' : '#f8a300'
                                    }}>
                                        {order.SitTp} </h6> </h6>
                                </div>


                            </div>
                            <div className='mt-4'>
                                <Accordion activeIndex={-1}>
                                    <AccordionTab header='محصولات'>
                                        {factorListMap
                                            .filter((item) => item.OrderId === order.Si)
                                            .map((factor, index, array) => (
                                                <div key={order.Si + '-' + factor.Code}>
                                                    <div className='row gy-4 mt-1'>
                                                        <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                                            <img src={Factor} alt="" />
                                                            <h6 className='m-0 f-14 '>کد کالا: {convertToPersianNumbers(factor.Code)}</h6>
                                                        </div>
                                                        <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                                            <img src={TextBox} alt="" />
                                                            <h6 className='m-0 f-14 '>نام کالا: {convertToPersianNumbers(factor.KalaName)}</h6>
                                                        </div>
                                                        <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                                            <img src={Box} alt="" />
                                                            <h6 className='m-0 f-14 '> تعداد کالا: {convertToPersianNumbers((factor.Nq).toString())}</h6>
                                                        </div>
                                                        <div className='col-md-4 col-lg-3 col-sm-12 d-flex align-items-center gap-2'>
                                                            <img src={Cards} alt="" />
                                                            <h6 className='m-0 f-14 number-font'>قیمت کل: {parseInt((factor.PayableRial).toString()).toLocaleString()} ریال</h6>
                                                        </div>
                                                    </div>

                                                    {index < array.length - 1 && <hr className="dashed-2" />}
                                                </div>
                                            ))}


                                    </AccordionTab>
                                </Accordion>
                            </div>

                            <div className='w-100 d-flex justify-content-end align-items-center gap-2 flex-wrap'>
                    {
                        order.Sit != 'B' && (
                            <button className='btn btn-outline-primary mt-3'  onClick={() => getPdf(order.Si)}><img src={Printer} /></button>

                        )
                    }
                                <button className='btn btn-outline-primary mt-3' onClick={() => openOrderDetail(order.Si)}>جزئیات سفارش</button>
                                <button className='btn btn-primary mt-3' onClick={() => openTicketDialog(order)}>ثبت تیکت</button>
                                {order.Acc == 'A' && order.Sit == 'C' && (

                                    <button className='btn btn-primary mt-3' onClick={() => { setVisiblePaymentDialog(true); setFactorId(order.Si) }}>آپلود فیش پرداخت</button>
                                )}
                            </div>
                        </div>
                    )}


                </div>
            </div>

            <Dialog
                draggable={false}
                dismissableMask
                visible={visibleDetailDialog}
                style={{ width: '35vw' }}
                breakpoints={{ '1800px': '35vw', '1600px': '35vw', '1400px': '50vw', '1100px': '60vw', '900px': '80vw', '600px': '400vw', '500px': '95vw' }}
                onHide={handleDialogClose}
                className="custom-dialog  dialog-profile"
                header="جزئیات سفارش"
            >
                <hr className='web' />
                <div className='row gy-4 gx-5 mt-2'>
                    {/* <hr className="dashed-2 my-1" /> */}
                    <div className='col-md-6 col-lg-6 col-sm-12 d-flex align-items-center gap-2'>
                        <img src={User} alt="" />
                        <h6 className=' m-0 f-14 number'>نام مشتری: {orderDetails?.customer}</h6>
                    </div>
                    <div className='col-md-6 col-lg-6 col-sm-12 d-flex align-items-center gap-2'>
                        <img src={User} alt="" />
                        <h6 className=' m-0 f-14 number'>نام گیرنده: {orderDetails?.nikename}</h6>
                    </div>
                    <div className='col-md-6 col-lg-6 col-sm-12 d-flex align-items-center gap-2'>
                        <img src={Phone} alt="" />
                        <h6 className=' m-0 f-14 number'>شماره تماس: {convertToPersianNumbers(orderDetails?.phone)}</h6>
                    </div>
                    <div className='col-md-6 col-lg-6 col-sm-12 d-flex align-items-center gap-2'>
                        <img src={City} alt="" />
                        <h6 className=' m-0 f-14 number'>شهر: {orderDetails?.city}</h6>
                    </div>

                    <div className='col-md-6 col-lg-6 col-sm-12 d-flex align-items-center gap-2'>
                        <img src={Calendar} alt="" />
                        <h6 className=' m-0 f-14 number'>تاریخ ثبت: {convertToPersianNumbers(orderDetails?.datesabt)}</h6>
                    </div>
                    <div className='col-md-6 col-lg-6 col-sm-12 d-flex align-items-center gap-2'>
                        <img src={Calendar} alt="" />
                        <h6 className=' m-0 f-14 number'>تاریخ تحویل: {convertToPersianNumbers(orderDetails?.datetahvil)}</h6>
                    </div>
                    <div className='col-md-6 col-lg-6 col-sm-12 d-flex align-items-center gap-2'>
                        <img src={Time} alt="" />
                        <h6 className=' m-0 f-14 number'>ساعت تحویل: {convertToPersianNumbers(orderDetails?.timetahvil)}</h6>
                    </div>
                    <div className='col-md-6 col-lg-6 col-sm-12 d-flex align-items-center gap-2'>
                        <img src={Payment} alt="" />
                        <h6 className=' m-0 f-14 number'>وضعیت پرداخت: {orderDetails?.acctp}</h6>
                    </div>
                    <div className='col-md-12 col-lg-12 col-sm-12 d-flex align-items-center gap-2'>
                        <img src={Map} alt="" />
                        <h6 className=' m-0 f-14 number'>آدرس: {orderDetails?.addres}</h6>
                    </div>

                </div>
            </Dialog>

            <Dialog
                draggable={false}
                dismissableMask
                visible={visibleTicketDialog}
                style={{ width: '50vw' }}
                breakpoints={{ '1800px': '45vw', '1600px': '35vw', '900px': '60vw', '600px': '400vw', '500px': '95vw' }}
                onHide={handleTicketDialogClose}
                className="custom-dialog dialog-profile"
                header="ثبت تیکت"
            >
                <hr className=" my-1 mb-2" />
                <div className=''>
                    <AddTicket orderNum={orderNum} />

                </div>
            </Dialog>

            <Dialog
                draggable={false}
                dismissableMask
                visible={visiblePaymentDialog}
                style={{ width: '35vw' }}
                breakpoints={{ '1800px': '45vw', '1600px': '35vw', '900px': '60vw', '600px': '400vw', '500px': '95vw' }}
                onHide={() => setVisiblePaymentDialog(false)}
                className="custom-dialog dialog-profile"
                header="رسید پرداخت"
            >
                <hr className=" mb-1 mt-0" />
                <Form className='row gy-2 mt-2' noValidate validated={validated} onSubmit={(e) => uploadForm(e)}>
                    <Form.Group className="col-6 ">
                        <Form.Label>تاریخ پرداخت <span className='text-[red]'> * </span></Form.Label>
                        <DatePicker
                            weekDays={weekDays}
                            value={paymentData}
                            onChange={(date) => setPaymentDate(convertDateToPersian(date.toDate()))}
                            calendar={persian}
                            locale={persian_fa}

                        />
                    </Form.Group>
                    <Form.Group className="col-6">
                        <Form.Label>مبلغ <span className='text-[red]'> * </span></Form.Label>
                        <div className=''>
                            <Form.Control className='number-font' required type="text" value={formatAmount(paymentAmount)} // Apply formatting to the displayed value
                                onChange={(e) => handleAmountChange(e.target.value)} />

                            <Form.Control.Feedback type="invalid">
                                مبلغ را وارد کنید.
                            </Form.Control.Feedback>
                        </div>
                    </Form.Group>
                    <Form.Group className="col-6">
                        <Form.Label>شماره حساب <span className='text-[red]'> * </span></Form.Label>
                        <div className=''>
                            <Form.Control required type="number" value={paymentAccount} onChange={(e) => setPaymentAccount(e.target.value)} />

                            <Form.Control.Feedback type="invalid">
                                شماره حساب را وارد کنید.
                            </Form.Control.Feedback>
                        </div>
                    </Form.Group>
                    <Form.Group className="col-6">
                        <Form.Label>شماره پیگیری <span className='text-[red]'> * </span></Form.Label>
                        <div className=''>
                            <Form.Control required type="text" value={trackingNumber} onChange={(e) => setTrackingNumber(e.target.value)} />

                            <Form.Control.Feedback type="invalid">
                                شماره پیگیری را وارد کنید.
                            </Form.Control.Feedback>
                        </div>
                    </Form.Group>
                    <Form.Group className="col-12">
                        <Form.Label>توضیحات </Form.Label>
                        <div className=''>
                            <Form.Control as="textarea" type="text" value={description} onChange={(e) => setDescription(e.target.value)} />


                        </div>
                    </Form.Group>



                    <div className=''>
                        <h6 className='my-4'>رسید پرداخت را آپلود کنید.</h6>
                        <div className="file-upload-container" onClick={handleFileClick}>
                            <input type="file" onChange={handleFileChange} id="file-upload" style={{ display: 'none' }} accept=".jpg,.jpeg,.png,.pdf" />
                            <img src={UploadIcon} alt="Upload Icon" />
                            <h6 className='text-xs font-medium mt-2'>
                                {file ? file.name : 'رسید پرداخت را از این قسمت وارد کنید.'}
                            </h6>
                        </div>
                        {filePreview && (
                        <div className=' '>
                            <img src={filePreview} alt="Preview" className="img-preview mt-2 aspect-[4/4] rounded-lg" width={150}  />
                        </div>
                    )}
                        <button type='submit' className='btn btn-primary w-100 mt-3'>ارسال جهت بررسی {loader && <Loader />}</button>

                    </div>  </Form>
            </Dialog>

        </div>
    );
}

export default Orders;
